<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="用户昵称" prop="userId">
                  <a-input v-model="queryParam.userName" placeholder="请输入用户昵称" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="storeName">
                <a-input v-model="queryParam.storeName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="赛事标题" prop="storeId">
                  <a-input v-model="queryParam.competitionTitle" placeholder="请输入赛事标题" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 增加修改 -->
      <show-content
        ref="showContent"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered">

        <span slot="video" slot-scope="text,record">
              <div class="imgbox margin-center" @click="showDetail(record.video)">
                <div class="videomask">
                  <a-icon class="icon" type="play-circle" />
                </div>
                <img  style="width: 48px;height: 48px;"  :src="record.video + '?x-oss-process=video/snapshot,t_30000,f_jpg,w_0,h_0,m_fast,ar_auto'" alt=""
                     class="response">
              </div>
        </span>

        <img style="width: 48px;height: 48px;" preview="封面" :src="record.cover" v-if="record.cover != null && record.cover != ''" slot="cover" slot-scope="text, record">

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.applicationStatus == 0">
            审核
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.showContent.handleUpdate(record, undefined)">
            查看内容
          </a>
          <a-divider type="vertical"/>
          <a @click="handleDelete(record)">
            下架
          </a>
        </span>
      </a-table>

      <!-- 视频预览播放 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <!-- <img alt="example" style="width: 100%" :src="previewImage" /> -->
        <video style="width: 100%" :src="previewImage" ref="myVideo"
               :poster=" previewImage + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVideo,delVideo } from '@/api/platform/video'
import CreateForm from './modules/CreateForm'
import ShowContent from './modules/ShowContent'

import { tableMixin } from '@/store/table-mixin'
import Video from '@/views/video/modules/Video'

export default {
  name: 'Video',
  components: {
    CreateForm,
    ShowContent,
    Video
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      previewVisible: false,
      previewImage: '',
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        cover: null,
        coverThumb: null,
        coverWidth: null,
        coverHigh: null,
        coverSize: null,
        audioId: null,
        video: null,
        type: null,
        competitionId: null,
        userId: null,
        storeId: null,
        praiseNum: null,
        readNum: null,
        collectionNum: null,
        shareNum: null,
        rewardNum: null,
        topicId: null,
        content: null,
        atUserIds: null,
        keyword: null,
        country: null,
        provinceName: null,
        cityName: null,
        countyName: null,
        detailedAddress: null,
        longitude: null,
        dimensionality: null,
        permissionType: null,
        isPk: null,
        noPkPay: null,
        isPkEarnings: null,
        pkIntegral: null,
        isWatermark: null,
        isDistinct: null,
        isDownload: null,
        transmitType: null,
        commentType: null,
        applicationStatus: null,
        refusalCause: null,
        rate: null,
        isRecommend: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '作品封面',
          dataIndex: 'cover',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "cover"}
        },
        {
          title: '视频',
          dataIndex: 'video',
          ellipsis: true,
          align: 'center',
          width: 60,
          scopedSlots: {customRender: "video"}
        },
       /* {
          title: '赛事标题',
          dataIndex: 'competitionTitle',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '用户昵称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
      /*  {
          title: '店铺名称',
          dataIndex: 'storeName',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '打赏总金额',
          dataIndex: 'rewardNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '话题标题',
          dataIndex: 'topicTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'PK收取战刀',
          dataIndex: 'pkIntegral',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'applicationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "审核中"
            }
            if (value == 1){
              return "已同意"
            }
            if (value == 2){
              return "已拒绝"
            }
          }
        },
        {
          title: '拒绝原因',
          dataIndex: 'refusalCause',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (value,record) {
            if (value == 1){
              return "下架"
            }
            if (value == 0){
              return "正常"
            }
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询视频-信息列表 */
    getList () {
      this.loading = true
     pageVideo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    showDetail(video){
      this.previewImage = video;
      this.previewVisible = true;
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        cover: undefined,
        coverThumb: undefined,
        coverWidth: undefined,
        coverHigh: undefined,
        coverSize: undefined,
        audioId: undefined,
        video: undefined,
        type: undefined,
        competitionId: undefined,
        userId: undefined,
        storeId: undefined,
        praiseNum: undefined,
        readNum: undefined,
        collectionNum: undefined,
        shareNum: undefined,
        rewardNum: undefined,
        topicId: undefined,
        content: undefined,
        atUserIds: undefined,
        keyword: undefined,
        country: undefined,
        provinceName: undefined,
        cityName: undefined,
        countyName: undefined,
        detailedAddress: undefined,
        longitude: undefined,
        dimensionality: undefined,
        permissionType: undefined,
        isPk: undefined,
        noPkPay: undefined,
        isPkEarnings: undefined,
        pkIntegral: undefined,
        isWatermark: undefined,
        isDistinct: undefined,
        isDownload: undefined,
        transmitType: undefined,
        commentType: undefined,
        applicationStatus: undefined,
        refusalCause: undefined,
        rate: undefined,
        isRecommend: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认下架所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/video/export', {
            ...that.queryParam
          }, `视频-信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less">

.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 50px;
  height: 50px;
  margin: 0 4px 4px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  line-height: 55px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 18px !important;
    color: #fff !important;
  }
}
</style>